import { CLEAR_SEARCHABLE_EMPLOYEES } from "../../../enums/Employees/employees.types";

export const clearSearchableEmployeesAction = () => {
    return {
        type: CLEAR_SEARCHABLE_EMPLOYEES,
    };
};